import { createFileRoute } from "@tanstack/react-router"
import DesignSystemCodeBlock from "~/pages/design-system/components/CodeBlock"

export const Route = createFileRoute("/_auth/internal/design-system/components/code-block")({
  staticData: { skipSkuStoreData: true },
  component: RouteComponent,
})

function RouteComponent() {
  return <DesignSystemCodeBlock />
}
